import { render, staticRenderFns } from "./SessionTitle.vue?vue&type=template&id=60db6045&"
import script from "./SessionTitle.vue?vue&type=script&lang=js&"
export * from "./SessionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports